import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import theme from "./utils/theme";
import reportWebVitals from "./reportWebVitals";
import store from "./store";

import { CssBaseline, GlobalStyles, ThemeProvider } from "@mui/material";

import App from "./App";

const globalStyles = (
  <GlobalStyles
    styles={{
      a: {
        "&:hover": {
          textDecoration: "underline",
        },
        "&:active": {
          color: "#ff5100",
        },
        "&:visited": {
          color: "#201751",
        },
        color: "#201751",
        textDecoration: "none",
      },
    }}
  />
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {globalStyles}
      <Provider store={store}>
        <App />
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
